import { z } from "zod";

const amount = z.number().nullable();

export const reportAppointment = z.object({
  id: z.string(),
  status: z.string(),
  date: z.string().nullable(),
  individual_payment: amount,
  unit: z.string().nullable(),
  created_at: z.string().nullable(),
});
export type ReportAppointment = z.infer<typeof reportAppointment>;

export const reportInvoice = z.object({
  id: z.string(),
  amount,
  status: z.string().nullable(),
  due_date: z.string().nullable(),
  created_at: z.string().nullable(),
  appointment: z.object({ id: z.string(), individual_payment: amount, unit: z.string().nullable() }).nullable(),
});
export type ReportInvoice = z.infer<typeof reportInvoice>;

export const reportData = z.object({
  appointments: z.array(reportAppointment),
  invoices: z.array(reportInvoice),
});
export type ReportData = z.infer<typeof reportData>;
